import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Preloader from "./components/Preloader";
import { AuthProvider } from "./contexts/AuthContext";
import GlobalMaintenanceWrapper from "./components/GlobalMaintenanceWrapper";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <GlobalMaintenanceWrapper>
            <Preloader />
            <AppRoutes />
          </GlobalMaintenanceWrapper>
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
